export default __webpack_public_path__ + "static/media/tutorial4-4.443695f5.png";